var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('b-table',{staticClass:"m-0 print-tables",attrs:{"fields":_vm.fields,"items":_vm.tableData,"borderless":"","small":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }